import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const processInstanceHistory = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    eventType: z
      .enum([
        'Started',
        'Data Updated',
        'User Task Completed',
        'Service Task Completed',
        'Message Received',
        'Paused',
        'Resumed',
        'Error Occurred',
        'Error Cleared',
        'Reprocessed',
        'Terminated',
        'Completed',
      ])
      .describe('What happened to the process instance'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('Additional details about what changed'),

    timestamp: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this event occurred'),

    processInstanceId: z
      .uuid()
      .hidden()
      .describe('Foreign key to ProcessInstance'),

    processInstance: belongsTo('ProcessInstance'),
  })
  .describe("Records each significant event in a process instance's lifecycle")
  .as('ProcessInstanceHistory');

export { processInstanceHistory as processInstanceHistorySchema };
